/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Problem_IntroInputs */

const en_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`But there's a little problem:`)
};

const de_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur gibt es da ein kleines Problem:`)
};

const zh_tw_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`但是遇到了一點問題：`)
};

const zh_cn_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`但是遇到了一点问题：`)
};

const es_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pero hay un pequeño problema:`)
};

const fr_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais il y a un petit souci :`)
};

const it_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è solo un piccolo problema:`)
};

const pt_br_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só que tem um probleminha:`)
};

const ja_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こんな問題、ありませんか：`)
};

const ko_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`근데 문제가 좀 있죠:`)
};

const ru_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Но есть одна загвоздка:`)
};

const th_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แต่ติดอยู่นิดหน่อย:`)
};

const tr_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ama ufak bir sorun var:`)
};

const ar_problem_intro = /** @type {(inputs: Problem_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لكن هناك عقبة صغيرة:`)
};

/**
* | output |
* | --- |
* | "But there's a little problem:" |
*
* @param {Problem_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const problem_intro = /** @type {((inputs?: Problem_IntroInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Problem_IntroInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_problem_intro(inputs)
	if (locale === "de") return de_problem_intro(inputs)
	if (locale === "zh_tw") return zh_tw_problem_intro(inputs)
	if (locale === "zh_cn") return zh_cn_problem_intro(inputs)
	if (locale === "es") return es_problem_intro(inputs)
	if (locale === "fr") return fr_problem_intro(inputs)
	if (locale === "it") return it_problem_intro(inputs)
	if (locale === "pt_br") return pt_br_problem_intro(inputs)
	if (locale === "ja") return ja_problem_intro(inputs)
	if (locale === "ko") return ko_problem_intro(inputs)
	if (locale === "ru") return ru_problem_intro(inputs)
	if (locale === "th") return th_problem_intro(inputs)
	if (locale === "tr") return tr_problem_intro(inputs)
	return ar_problem_intro(inputs)
});